import { promiseActionMiddleware } from "fredux";
import { createStore, applyMiddleware } from "redux";
import reducers from "application/reducer/reducers";

const store = createStore(reducers, applyMiddleware(promiseActionMiddleware));

export default store;
